import { useState, SyntheticEvent, useEffect } from 'react'
import { Button, RadioInput, OnBoardingLayout } from '@components'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import axios from 'axios'
import { OnBoardingAccreditedInvestorProgressLoader } from '@loaders'
import { Mixpanel } from '@utils'

interface FormValues {
  accreditationStatus: string
}

const AccreditedInvestorOptions = [
  {
    id: '1',
    label: `My net worth, or my joint net worth with my spouse, exceeds $1M, excluding the value of my primary residence.`,
    value: `My net worth, or my joint net worth with my spouse, exceeds $1M, excluding the value of my primary residence.`,
  },
  {
    id: '2',
    label: `My income exceeded $200K in each of the past two years and I expect the same this year.`,
    value: `My income exceeded $200K in each of the past two years and I expect the same this year.`,
  },
  {
    id: '3',
    label: `My joint income, with my spouse, exceeded $300K in each of the past two years and I expect the same this year.`,
    value: `My joint income, with my spouse, exceeded $300K in each of the past two years and I expect the same this year.`,
  },
  {
    id: '4',
    label:
      'I am a designated financial representative that holds in good standing a FINRA Series 7, 65, or 82 license.',
    value:
      'I am a designated financial representative that holds in good standing a FINRA Series 7, 65, or 82 license.',
  },
  {
    id: '5',
    label:
      'I am a non-US investor and qualify as the equivalent of an accredited or qualified investor in my country of residence.',
    value:
      'I am a non-US investor and qualify as the equivalent of an accredited or qualified investor in my country of residence.',
  },
]

const AccreditedInvestor: NextPage = props => {
  const router = useRouter()
  const [submitting, setSubmitting] = useState(false)
  const [currentProfile, setCurrentProfile] = useState<any>()
  const [values, setValues] = useState<FormValues>({
    accreditationStatus: '',
  })
  const [loading, setLoading] = useState<boolean>(true)

  const setValue = (value: any, name: keyof FormValues) => {
    setValues({ ...values, [name]: value })
  }

  const submitForm = async (e: SyntheticEvent) => {
    e.preventDefault()
    setSubmitting(true)

    if (currentProfile?.accreditationStatus === values.accreditationStatus)
      router.push('/on-boarding/relevant-investment-experience')
    else
      await axios
        .patch(process.env.NEXT_PUBLIC_API_URL + '/me/update-profile', {
          accreditationStatus: values.accreditationStatus,
        })
        .then(res => {
          router.push('/on-boarding/relevant-investment-experience')
        })
        .catch(err => {
          setSubmitting(false)
        })
  }

  useEffect(() => {
    Mixpanel.track('Onboarding-Enter-accredited-investor-type')
  }, [])

  useEffect(() => {
    axios
      .get(process.env.NEXT_PUBLIC_API_URL + `/me/current-profile`)
      .then(response => {
        const { accreditationStatus } = response.data?.profile
        setCurrentProfile(response.data?.profile)
        setValues({
          accreditationStatus,
        })
        setLoading(false)
      })
      .catch(error => {
        console.log(error)
        setLoading(false)
      })
  }, [])

  return (
    <OnBoardingLayout
      imgPath={'https://mx-documents.s3.amazonaws.com/accredited-investor.png'}>
      <div className="mx-auto mt-4 w-[88%] md:mx-0 md:mt-0 md:w-[58%]">
        {loading ? (
          <div className="mx-auto mt-0 w-[80%] md:mx-0 md:w-[60%]">
            <OnBoardingAccreditedInvestorProgressLoader />
          </div>
        ) : (
          <>
            <p className="pb-4 text-themeBlack">
              Are you an{' '}
              <span className="text-lg font-semibold">
                Accredited Investor?
              </span>
            </p>
            <p className="w-full pb-4 text-base text-themeBlack md:w-4/5">
              To sign up for a MarketX account as an Individual Investor, you
              must be Accredited. If you meet the criteria of any of the
              statements below, you’re considered accredited. Please select one
              which applies.
            </p>
            <form onSubmit={submitForm}>
              <div className="w-full pb-10 md:w-[74%]">
                <div className="flex w-full flex-col ">
                  <div className="w-full">
                    <RadioInput
                      required
                      value={values.accreditationStatus}
                      onChange={(e: any) => {
                        setValue(e, 'accreditationStatus')
                      }}
                      name="accreditedInvestor"
                      options={AccreditedInvestorOptions}
                    />
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <Button
                  light
                  onClick={() => {
                    router.back()
                  }}>
                  Back
                </Button>
                <div className="ml-4">
                  <Button submit loading={submitting} disabled={submitting}>
                    Next
                  </Button>
                </div>
              </div>
            </form>
          </>
        )}
      </div>
    </OnBoardingLayout>
  )
}

export default AccreditedInvestor
